<template>
  <v-data-table
    :class="['data-table']"
    :headers="headers"
    :items="items"
    :search="search"
    :no-data-text="''"
    :no-results-text="''"
    :hide-actions="true"
  >
    <template v-slot:items="props">
      <td
        v-for="col in config.columns"
        :key="col.value"
        @click="!col.action && onEdit(props.item.id)"
        :class="['cell', col.class]"
      >
        <template v-if="!col.action">
          {{ props.item[col.value] }}
        </template>
        <template v-else>
          <img
            v-if="col.action === 'edit' && event.main_actions"
            src="/img/edit-b.svg"
            alt="edit"
            @click.stop="onEdit(props.item.id)"
          />
          <img
            v-if="col.action === 'delete' && event.main_actions"
            src="/img/error.svg"
            alt="delete"
            @click.stop="onRemove(props.item.id)"
          />
          <img
            v-if="col.action === 'transfer' && event.main_actions"
            src="/img/transfer.svg"
            alt="transfer"
            @click.stop="onTransfer(props.item.id)"
          />
        </template>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DataTableWrapper',
  props: {
    config: { type: Object, required: true },
    items: { type: Array, required: true },
    search: { type: String, default: '' },
    event: { type: Object, required: true }
  },
  computed: {
    ...mapGetters({ getCurrentEvent: 'getCurrentEvent' }),
    headers () {
      return this.config.columns.map(col => ({
        text: this.$t(col.textKey),
        value: col.value || col.textKey,
        sortable: !!col.sortable,
        width: col.width || null
      }))
    },
    variant () {
      return this.config.variant || 'default'
    }
  },
  methods: {
    onEdit (id) {
      this.$emit('edit', id)
    },
    onRemove (id) {
      this.$emit('remove', id)
    },
    onTransfer (id) {
      this.$emit('transfer', id)
    }
  }
}
</script>

<style lang="scss" scoped>
.cell {
  border: 1px solid #e3e5f3 !important;
  padding: 12px !important;
  text-align: left !important;
  border-left: 0 !important;
  border-right: 0 !important;
  min-width: 60px !important;
}

.delete,
.transfer,
.edit {
  img {
    width: 20px;
    height: 20px;
    opacity: 0.9;
    cursor: pointer;
  }
}
</style>
